import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["selector", "pickFellow", "createFellow"]

    get selected() {
        return this.selectorTarget.value
    }

    connect() {
        this.changeSelector()
    }

    changeSelector() {
        this.pickFellowTarget.style.display = this.displayFor("pick")
        this.createFellowTarget.style.display = this.displayFor("create")
    }

    displayFor(type) {
        return type === this.selected ? "block" : "none"
    }
}
